export {
  getAssessmentIcon,
  getColor,
  getFeedback,
  getPhaseFeedback,
  getTimestamp,
  saveCommentLog,
  saveAnalysisLog,
  saveLog,
  applyFBTemplate
} from "./debriefingUtils";
export { doVitalsCounts } from "./inferencing";
export { analyzeEvents } from "./analyzeEvents";
//export { doVitalsCounts } from "./vitalsChecking";

export { summarizeAnalysis } from "./summarizeAnalysis";
// setC2FB, ,  c2FB , setRequiredPhaseNames
